export default {
  token: {
    fontFamily: ['SF UI Text', 'ui-sans-serif', 'system-ui', '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Helvetica Neue', 'Arial', 'Noto Sans', 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'],
    colorPrimary: '#0d0e0f',
    colorPrimaryHover: '#6d6f71',
    colorPrimaryBorderHover: '#6d6f71',
    colorPrimaryBg: '#c8cacc',
  },
};
